export default "__VITE_ASSET__B6lgg$rq__"